
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA-XqoBPQcDX_GFxf3TH53vcQETenmmQqY",
  authDomain: "billerq-us-staging.firebaseapp.com",
  projectId: "billerq-us-staging",
  storageBucket: "billerq-us-staging.firebasestorage.app",
  messagingSenderId: "333875122048",
  appId: "1:333875122048:web:a0e11a491e3b2ad3f77b65",
  measurementId: "G-PCL9VB556M"
};
const firebaseApp = initializeApp(firebaseConfig);
export const getFirebaseMessaging = async () => {
  const supported = await isSupported();
  if (!supported) {
    console.warn("🚫 Push messaging not supported in this browser.");
    return null;
  }
  return getMessaging(firebaseApp);
};

// export { messaging};


